export default {
  title: 'Liste des blockchains prises en charge par KeyPal (1000+)',
  getKeypal: 'Obtenez votre KeyPal',
  comingSoon: 'Bientôt disponible',
  list: {
    title: 'Blockchain',
    detail: 'Détails',
    urlName: 'Lien',
  },
}
